export const locale = {
    lang: 'nl',
    data: {
        'PLANNINGOVERZICHT': {
            'FILTERAFDELING': 'Filter op een afdeling',
            'FILTERTEXT': 'Filter op text'
        },
    }
};
